import script from "./RegisterItemsForm.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterItemsForm.vue?vue&type=script&setup=true&lang=js"

import "./RegisterItemsForm.vue?vue&type=style&index=0&id=5253b1e2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5253b1e2"]])

export default __exports__